// 从 saas-editor/src/listCard/views/wheelCard/index.tsx 搬迁
import React, { useCallback, useState } from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import './index.less';

interface IProps {
    children: React.ReactNode;
    cardWidth: number;
    cardMargin: number;
    cardLength: number;
    count?: number;
    rightText?: string | React.ReactElement;
    title?: string;
    onClick?: Function;
    width?: number;
}
// 默认每行最大个数
const MAX_NUM = 3;
export const WheelCard = React.memo((props: IProps) => {
    const { $t } = useLocaleStore();
    const {
        children,
        rightText = $t((v) => v.listCard.rightText),
        title,
        onClick,
        width,
        count = MAX_NUM,
        cardWidth,
        cardMargin,
        cardLength,
    } = props;
    const [active, setActive] = useState<number>(0);

    const handleMoreClick = useCallback(() => {
        onClick && onClick();
    }, []);

    const RenderIcon = React.memo(() => {
        return <IconFont name="ChevronLeftBlack" fontSize={14} />;
    });
    return (
        <div className="mt-list-wheel-card" style={{ width: width || 'auto' }}>
            <div className="mt-list-wheel-card__header">
                <div className="mt-list-wheel-card__title">{title}</div>
                {rightText ? (
                    <div onClick={handleMoreClick} className="mt-list-wheel-card__btn">
                        <span>{rightText}</span>
                    </div>
                ) : null}
            </div>
            <div className="mt-list-wheel-card__body">
                {cardLength > count && active !== 0 ? (
                    <div
                        className="mt-list-wheel-card__prev"
                        onClick={() => {
                            setActive((num) => {
                                num--;
                                return num;
                            });
                        }}
                    >
                        <RenderIcon />
                    </div>
                ) : null}
                <div style={{ overflow: 'hidden' }}>
                    <div
                        className="mt-list-wheel-card__list"
                        style={{
                            marginLeft: -active * (cardMargin + cardWidth) * count,
                        }}
                    >
                        {children}
                    </div>
                </div>
                {cardLength > count && (active + 1) * count < cardLength ? (
                    <div
                        className="mt-list-wheel-card__next"
                        onClick={() => {
                            setActive((num) => {
                                num++;
                                return num;
                            });
                        }}
                    >
                        <IconFont name="ChevronRightBlack" fontSize={14} />
                    </div>
                ) : null}
            </div>
        </div>
    );
});
